import React, { useEffect, useRef } from 'react'
import { CurrentTimeIndicator } from '@devexpress/dx-react-scheduler-material-ui'

import Box from '@mui/material/Box'

import colors from '@/assets/scss/_themes-vars.module.scss'

export function TimeIndicator(props: CurrentTimeIndicator.IndicatorProps) {
  const { top } = props
  const indicatorRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    indicatorRef.current?.scrollIntoView({ block: 'center' })
  }, [])

  return (
    <Box ref={indicatorRef}>
      <Box
        sx={{
          position: 'absolute',
          zIndex: 1,
          left: 0,
          top,
          width: (theme) => theme.spacing(1.5),
          height: (theme) => theme.spacing(1.5),
          borderRadius: '50%',
          transform: 'translate(-50%, -50%)',
          background: colors.red600,
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          zIndex: 1,
          left: 0,
          top,
          height: '2px',
          borderTop: `2px ${colors.red600} solid`,
          width: '100%',
          transform: 'translate(0, -1px)',
        }}
      />
    </Box>
  )
}

export default TimeIndicator